import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { errorToast, successToast } from "../../../utils/toasts";
import type { CreateTagRequest, Tag } from "../../../zodios/apiDefinitions/api/tags";
import { invalidateTagAffectedQueries } from "./invalidateTagAffectedQueries";

interface TagListCache {
  count: number;
  next: string | null;
  previous: string | null;
  results: Tag[];
}

export const useCreateTagMutation = () => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(["tags"]);
  return useMutation({
    mutationFn: async (payload: CreateTagRequest) => await apiClient.createTag(payload),
    onSuccess: (createdTag) => {
      successToast({ message: t(($) => $.tags["Tag created successfully"]) });
      queryClient.setQueriesData<TagListCache>(
        { queryKey: [{ entity: "tags", params: { entityType: createdTag.entity_type } }] },
        (old) => (old ? { ...old, count: old.count + 1, results: [createdTag, ...old.results] } : old),
      );
      invalidateTagAffectedQueries(queryClient);
    },
    onError: (error) => {
      errorToast({ message: t(($) => $.tags["Failed to create tag"]), error });
    },
  });
};
